import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";

import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { useEffect, useState } from "react";

const BorderLinearProgress = styled(LinearProgress)(() => ({
  width: 42,
  height: 4,
  borderRadius: 26,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#E5E7EB",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 26,
    backgroundColor: "#5B3FFF",
  },
}));

export default function CustomizedProgressBars({ fast = false }) {
  const [progress, setProgress] = useState(10);
  useEffect(() => {
    const interval = setInterval(
      () => {
        setProgress((prevProgress) => {
          const next = prevProgress + 3;
          return next >= 100 ? 100 : next;
        });
      },
      fast ? 300 : 3000
    ); // 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);
  return (
    <Stack spacing={2} sx={{ flexGrow: 1 }}>
      <BorderLinearProgress variant="determinate" value={progress} />
    </Stack>
  );
}
